module.exports = __webpack_public_path__ + "static/media/cattle-drones-twitter.62cc9758.jpg";